module.exports = __webpack_public_path__ + "img/643.778f0295.jpg";